module.exports = __webpack_public_path__ + "account/assets/higher.f7b2de49.svg";